import { Anchor, Card, Stack, Text } from '@mantine/core'
import { Link } from '@tanstack/react-router'

export function CostsHelpCard() {
  return (
    <Card withBorder radius="lg" p="md" bg="gray.0">
      <Stack gap="xs">
        <Text size="sm" fw={500}>
          💡 Kustannusten hallinta
        </Text>
        <Text size="sm" c="dimmed">
          • Lisää kustannuksia{' '}
          <Anchor to="/maintenance" size="sm" component={Link}>
            Huoltokirjassa
          </Anchor>
        </Text>
        <Text size="sm" c="dimmed">
          • Voit myös lisätä kustannuksia suoraan tällä sivulla
          "Lisää"-painikkeella
        </Text>
        <Text size="sm" c="dimmed">
          • Budjetoidut kustannukset lasketaan tehtävien arvioista
        </Text>
        <Text size="sm" c="dimmed">
          • Muokkaa tai poista kustannuksia avaamalla yksittäinen huoltomerkintä
        </Text>
      </Stack>
    </Card>
  )
}
